// Generated by purs version 0.15.15
import * as $foreign from "./foreign.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Specular_Select from "../Specular.Select/index.js";
import * as Unsafe_Coerce from "../Unsafe.Coerce/index.js";
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var initSelect2 = function () {
    return $foreign.initSelect2Impl;
};
var group = Unsafe_Coerce.unsafeCoerce;
var fromSingleOption = function (dictToOptionId) {
    var toOptionId = Specular_Select.toOptionId(dictToOptionId);
    return function (opt) {
        return {
            id: toOptionId(opt.key),
            option: opt.key,
            text: opt.label
        };
    };
};
var entry = Unsafe_Coerce.unsafeCoerce;
var fromSelectOptions = function (dictToOptionId) {
    var fromSingleOption1 = fromSingleOption(dictToOptionId);
    return map(function (v) {
        if (v instanceof Specular_Select.OptGroup) {
            return group({
                text: v.value0.label,
                children: map(fromSingleOption1)(v.value0.options)
            });
        };
        if (v instanceof Specular_Select.SingleOption) {
            return entry(fromSingleOption1(v.value0));
        };
        throw new Error("Failed pattern match at Restaumatic.Components.MultiSelect (line 59, column 3 - line 63, column 35): " + [ v.constructor.name ]);
    });
};
export {
    getValues,
    setValues,
    getValue,
    setValue,
    open
} from "./foreign.js";
export {
    initSelect2,
    fromSingleOption,
    entry,
    group,
    fromSelectOptions
};
